import { inject } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { FilingOption } from '@app/services/filing-options/types/filing-options';
import { FilingOptionsService } from '@app/services/filing-options/services/filing-options.service';
import { firstValueFrom } from 'rxjs';

type FilingOptionsState = {
    isLoading: boolean;
    filingOptions: FilingOption[];
    error: string | null;
};

const defaultState: FilingOptionsState = {
    isLoading: false,
    filingOptions: [],
    error: null,
};

export const FilingOptionsStore = signalStore(
    { providedIn: 'root' },
    withState(defaultState),
    withComputed((state) => ({
        filingOptions: state.filingOptions,
        isLoading: state.isLoading,
        error: state.error,
    })),
    withMethods((store, filingOptionsService = inject(FilingOptionsService)) => ({
        reset() {
            patchState(store, defaultState);
        },
        async loadFilingOptions(serviceTypeId: string, supplierId: string) {
            patchState(store, { isLoading: true, error: null });
            try {
                const filingOptions = await firstValueFrom(
                    filingOptionsService.getFilingOptionsByServiceTypeAndSupplier(serviceTypeId, supplierId),
                );
                patchState(store, {
                    isLoading: false,
                    filingOptions,
                });
            } catch (error) {
                patchState(store, {
                    isLoading: false,
                    error: error instanceof Error ? error.message : 'An error occurred while loading filing options',
                });
            }
        },
    })),
);
